import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { PlanConfigurationPriceService } from "../../domain/price/plan-configuration-price.service";

export const PlanConfigurationCheckoutGuard: CanActivateFn = () => {
  const router = inject(Router);
  const planConfigurationService = inject(PlanConfigurationPriceService);

  if (planConfigurationService.selectedProducts().length > 0) {
    return true;
  }

  return router.parseUrl("/plan-configuration");
};
